import { Dispatch } from 'react';

import { AddPhotoAction } from './addPhoto.enum';
import { AddPhotoActions } from './addPhoto.types';

export const setFileProgressValuesAction: (
  dispatch: Dispatch<AddPhotoActions>, fileName: string, percentLoaded?: number
) => void = (dispatch: Dispatch<AddPhotoActions>, fileName: string, percentLoaded?: number): void => {
  dispatch({
    type: AddPhotoAction.SetFileProgressValues,
    payload: { fileName, percentLoaded }
  });
};
